import {action} from "mobx";
import courierWithdrawRequestService from "../services/courierWithdrawRequestService";
import appStore from "./appStore";
import i18n from "../i18n";

class CourierWithdrawRequestStore {
    @action getCourierWithdrawRequestList = async params => {
        const resultOfRequest = await courierWithdrawRequestService.courierWithdrawRequestList(
            params
        );
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getNetsisInvoices = async params => {
        const resultOfRequest = await courierWithdrawRequestService.netsisInvoices(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action requestCourierWithdrawList = async params => {
        return courierWithdrawRequestService.courierWithdrawRequestList(params);
    };

    @action makePaymentRequest = async params => {
        const resultOfRequest = await courierWithdrawRequestService.makePaymentRequest(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({
                title: resultOfRequest.data.message,
                content: i18n.t("stores.courierWithdrawRequestStore.makePaymentRequest.failedPaymentHint", {
                    ns: "common"
                })
            });
            return false;
        }
        appStore.openSuccessModal({
            title: resultOfRequest.data.message,
            content: i18n.t("stores.courierWithdrawRequestStore.makePaymentRequest.failedPaymentHint", {
                ns: "common"
            })
        });
        return true;
    };

    @action cancelPaymentRequest = async params => {
        const resultOfRequest = await courierWithdrawRequestService.cancelPaymentRequest(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        appStore.openSuccessModal({content: resultOfRequest.data.message});
        return true;
    };

    @action statusNames = async params => {
        const resultOfRequest = await courierWithdrawRequestService.statusNames(params);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    // Mükerrer numara hatası formda gösterileceği için burada global modal açılmıyor.
    @action addExpenseVoucher = async formData => {
        const resultOfRequest = await courierWithdrawRequestService.addExpenseVoucher(formData);
        if (resultOfRequest.status !== 200) {
            return {success: false, message: resultOfRequest.data?.message};
        }
        return {success: true, data: resultOfRequest.data};
    };
}

export default new CourierWithdrawRequestStore();
